"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DomainContext", {
  enumerable: true,
  get: function () {
    return _useDomainContext.DomainContext;
  }
});
Object.defineProperty(exports, "getFormatUrlMethods", {
  enumerable: true,
  get: function () {
    return _urlUtils.getFormatUrlMethods;
  }
});
Object.defineProperty(exports, "useDomainContext", {
  enumerable: true,
  get: function () {
    return _useDomainContext.useDomainContext;
  }
});
exports.useDomainGems = void 0;
var _react = require("react");
var _urlUtils = require("./otherPackage/url-utils");
var _useDomainContext = require("./otherPackage/useDomainContext");
var _OptionContext = require("./otherPackage/OptionContext");
// 目前当前模块不支持pnpm，只能用其他方式引用其他模块代码

/**
 * useDomainGems的额外配置
 * @typedef {Object} UseDomainGemsOptionsType
 * @property {DomainInfosType?} domainInfos
 */

/**
 * 根据当前域名获取各相关域名
 * @param options {UseDomainGemsOptionsType} 配置，可以直接传入域名。如果没有传入则会尝试用useContext来获取
 * @returns {DomainInfosType} 各类域名
 */
const useDomainGems = (options = {}) => {
  const _ref = options || {},
    domainInfos = _ref.domainInfos;
  const optionContext = (0, _react.useContext)(_OptionContext.OptionContext);
  if (domainInfos) return domainInfos;
  return optionContext === null || optionContext === void 0 ? void 0 : optionContext.domains;
};
exports.useDomainGems = useDomainGems;